<script>
		let src = '/media/bird.gif'
		let count = $state(0);
		function increment() {
		count += 1;
}
</script>

<main>
	<p>Let's see what we have here</p>
	
	<div>
		<button onclick={increment}>
			Clicked {count}
			{count === 1 ? 'time' : 'times'}
		</button>
	</div>

	<img {src} alt="bird">
</main>

<style>

	main {
		display: flex;
  		align-items: center;
  		justify-content: center;
		flex-direction: column;
		/* padding: 1em; */
		max-width: 240px;
		margin: 0 auto;
		color: #b1b1b1;
	}

	p {
		text-align: center;
	}

	img {
    max-width: 100%;
    max-height: 100%; 
  	}


</style>